import {
  BoltTaskRuleTypes,
  IBoltTaskRule,
  INewBoltTaskRule,
  useBoltApiClient,
} from "@bolt/core";
import { QueryBuilderComponent } from "@syncfusion/ej2-react-querybuilder";
import {
  AppToasterV2,
  FieldFormV2,
  FieldFormV2Module,
  Footer,
  ActionButtons,
  SchemaFactoryV2,
  useFieldSchemaV2,
  LoadingV2,
} from "@ucl/library";
import { RefObject, useEffect, useRef, useState } from "react";
import { editBoltTaskRuleBuilder } from "./builders/editBoltTaskRuleBuilder";
import { createBoltTaskApiClient } from "../../lib/apiClients/boltTaskApiClient";

export interface EditBoltTaskRuleFormProps {
  // extends BoltInteraction<
  //   {
  //     onSubmitSuccessfully: (taskRule: IBoltTaskRule) => Promise<void>;
  //   },
  //   {
  //     hasEditPermission: boolean;
  //   }
  // > {
  apiBaseUrl: string;
  getAuthRequestHeader: () => Promise<Record<string, string>>;
  taskRuleId: string;
  // currentUser: { id: string };
  onSave?: () => void;
  onCancel?: () => void;
}

export const EditBoltTaskRuleForm: React.FC<EditBoltTaskRuleFormProps> = ({
  apiBaseUrl,
  getAuthRequestHeader,
  taskRuleId,
  // actions,
  onSave,
  onCancel,
}) => {
  const boltApiClient = useBoltApiClient();
  const taskApiClient = createBoltTaskApiClient(boltApiClient);
  const [localTaskRule, setLocalTaskRule] = useState<
    IBoltTaskRule | INewBoltTaskRule
  >();
  const taskFormRef: RefObject<FieldFormV2Module<IBoltTaskRule> | null> =
    useRef<FieldFormV2Module<IBoltTaskRule>>(null);
  const queryBuilderRef = useRef<QueryBuilderComponent>(null);

  const [schemaFactory, setSchemaFactory] = useState<SchemaFactoryV2>();

  const { getAsyncSchemaFactory } = useFieldSchemaV2("tasks/field-schema");

  useEffect(() => {
    initializeData();
  }, []);

  const initializeData = async () => {
    // Get schema
    const factory = await getAsyncSchemaFactory(boltApiClient);
    setSchemaFactory(factory);

    // Get task rule
    const taskRule = await taskApiClient.getTaskRuleById(taskRuleId);
    setLocalTaskRule(taskRule);
  };

  const handleSubmit = async (taskRule: INewBoltTaskRule) => {
    //const taskRuleCondition = queryBuilderRef.current?.getRules();

    // await taskApiClient.updateTaskRule(taskRuleId, {
    //   ...taskRule,
    //   // ...taskRule,
    //   // ...(taskRule.taskRuleType === BoltTaskRuleTypes.Event && {
    //   //   eventCondition: {
    //   //     ...taskRule.eventCondition,
    //   //     rule: taskRuleCondition,
    //   //   },
    //   // }),
    //   // ...(taskRule.taskRuleType === BoltTaskRuleTypes.Time && {
    //   //   timeCondition: {
    //   //     ...taskRule.timeCondition,
    //   //     rule: taskRule.timeCondition?.rule.substring(
    //   //       0,
    //   //       taskRule.timeCondition?.rule.length - 1
    //   //     ),
    //   //   },
    //   // }),
    // });
    // // .then((_rule) => {
    // //   AppToasterV2.showSuccessAppToaster(
    // //     "Update task rule successfully."
    // //   );
    // //   onSave?.();
    // // })
    // // .catch(() => {
    // //   AppToasterV2.showSuccessAppToaster(
    // //     "Failed to update task rule."
    // //   );
    // // });

    await taskApiClient.updateTaskRule(taskRuleId, taskRule).then(() => {
      onSave?.();
      AppToasterV2.showSuccessAppToaster("Update task rule successfully.");
    });
  };

  // Show loading state if any required data is not ready
  if (!schemaFactory || !localTaskRule) {
    return (
      <div className="task-rule-form-loading">
        <LoadingV2 />
      </div>
    );
  }

  return (
    <div className="task-rule-form">
      <FieldFormV2<INewBoltTaskRule>
        ref={
          taskFormRef as RefObject<FieldFormV2Module<INewBoltTaskRule> | null>
        }
        fieldSchemaFormBuilder={editBoltTaskRuleBuilder(schemaFactory, {
          taskTypeProps: {
            apiBaseUrl: apiBaseUrl,
            getAuthRequestHeader: getAuthRequestHeader,
          },
          taskRuleTypeProps: {
            optionValues: (schemaFactory.schema as any).enumOptions
              .BoltTaskRuleTypes,
          },
          eventConditionProps: {
            hidden: true,
            apiBaseUrl: apiBaseUrl,
            getAuthRequestHeader: getAuthRequestHeader,
            queryBuilderRef: queryBuilderRef,
          },
          timeConditionProps: {
            hidden: localTaskRule.taskRuleType == BoltTaskRuleTypes.Event,
          },
        })}
        value={localTaskRule}
        onFormSubmit={handleSubmit}
        columns={3}
      />

      <Footer className="task-rule-form-footer">
        <ActionButtons
          actions={[
            {
              text: "Cancel",
              onActionClick: onCancel,
            },
            {
              text: "Save",
              isPrimary: true,
              onActionClick: () => {
                taskFormRef.current?.submit();
              },
            },
          ]}
        />
      </Footer>
      {/* <div className="task-rule-form-footer">
        <div className="task-rule-form-footer-cta-wrapper">
          <PrimaryButton
            text={"Save"}
            onClick={async () => {
              taskFormRef.current?.submit();
            }}
          />
        </div>
      </div> */}
    </div>
  );
};
